export const parseBooleanFlag = (value: unknown): boolean | undefined => {
  if (value === null || value === undefined) return undefined;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') {
    if (value === 1) return true;
    if (value === 0) return false;
  }
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (!normalized) return undefined;
    if (['1', 'true', 'yes', 'on', 'enabled'].includes(normalized)) return true;
    if (['0', 'false', 'no', 'off', 'disabled'].includes(normalized)) return false;
  }
  return undefined;
};

interface ResolveBooleanOptions {
  env?: unknown;
  runtime?: unknown;
  fallback?: boolean;
}

const resolveBooleanFlag = ({ env, runtime, fallback }: ResolveBooleanOptions): boolean => {
  const envValue = parseBooleanFlag(env);
  if (envValue !== undefined) return envValue;
  const runtimeValue = parseBooleanFlag(runtime);
  if (runtimeValue !== undefined) return runtimeValue;
  return fallback ?? false;
};

export const isMarketLandingEnabled = (): boolean =>
  resolveBooleanFlag({
    env: (import.meta.env as any)?.VITE_MARKET_LANDING,
    runtime: typeof window !== 'undefined' ? (window as any)?.API_CONFIG?.marketLanding : undefined,
    fallback: true,
  });

export const isStewardConsoleEnabled = (): boolean =>
  resolveBooleanFlag({
    env: (import.meta.env as any)?.VITE_STEWARD_CONSOLE,
    runtime: typeof window !== 'undefined' ? (window as any)?.API_CONFIG?.stewardConsole : undefined,
    fallback: true,
  });
